/* eslint-disable no-else-return */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import { AccountService } from 'gw-capability-gateway-policy';
import { withModalContext } from '@jutro/components';
import { MLLOBDisplayService , PolicyService } from 'gw-capability-gateway';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { FormModalPopover } from 'ml-components-platform-react';
import { withRouter } from 'react-router-dom';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import classNames from 'classnames';
import moment from 'moment';
import { MLTagManagerService } from 'ml-portals-services-react';
import mlclaimDetailPopup from '../../Components/MLClaimDetailPopup/MLClaimDetailPopup';
import metadata from './MLClaimSummary.metadata.json5';


import styles from './MLClaimSummary.module.scss';
import messages from './MLClaimSummary.messages';
import { Button } from '@jutro/legacy/components';

import { TranslatorContext } from '@jutro/legacy/locale';

class MLClaimSummaryWithoutModalContext extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string
            }),
            accountInfo: PropTypes.shape({})
        }).isRequired

    };

    state = {
        claimSummariesVM: [],
        policySummaries: [],
        policyWithClaims: [],
        isA360ServiceEnabled : false,
        IsEmptyResponse: false,
    };

    hasClaims = (accountClaims, policy) => {
        return accountClaims && !!accountClaims.find((claimVM) => claimVM.value.policyNumber === policy.policyNumber);
    };

    componentDidMount = () => {
        const {
            fromAccountLanding: {
                accountDetailsData: { accountNumber },
                accountInfo
            },
            authHeader,
            viewModelService
        } = this.props;

        PolicyService.getClaimsConsolidationEnabled(authHeader).then((response) => {
            this.setState({
                isA360ServiceEnabled : response
            });
        });

        AccountService.getAccountClaims(accountNumber, authHeader).then((responseData) => {
            if (_.isEmpty(responseData)) {
                this.setState({
                    IsEmptyResponse : true
                });
                return;
            }
            // eslint-disable-next-line max-len
            const accountClaims = responseData.map((claim) => viewModelService.create(claim, 'pc', 'edge.capabilities.gateway.claim.dto.ClaimSummaryDTO')
            );
            const policyWithClaims = _.filter(accountInfo.policySummaries, (policy) => this.hasClaims(accountClaims, policy));
            this.setState({
                claimSummariesVM: accountClaims,
                policyWithClaims: policyWithClaims
            });
        });

        this.setState({
            policySummaries: accountInfo.policySummaries
        });
    };

    getLobIconClassName = (policy) => {
        const lobPolicyName = MLLOBDisplayService.getLOBPolicyName(policy);
        if (lobPolicyName === 'Auto') {
            return "icon-ml-car-icon-outline";
        }
        if (lobPolicyName === 'Home' || lobPolicyName === 'Condo') {
            return "icon-ml-home-detailed-icon";
        }
        if (lobPolicyName === 'Umbrella') {
            return "icon-foremost-umbrella-icon";
        }
    }

    getPolicySummaryOverrides = () => {
        const {
            policyWithClaims,
            claimSummariesVM,
            IsEmptyResponse
        } = this.state;
        const translator = this.context;
        const overrides = policyWithClaims.map((policy, index) => {
            return {
                noDataMessageContainer: {
                    visible: _.isEmpty(claimSummariesVM) || IsEmptyResponse
                },
                noDataMessage: {
                    value: translator(messages.noClaimsResult)
                },
                [`lobIcon${index}`]: {
                    className: classNames('floatLeft', this.getLobIconClassName(policy))
                },
                [`lobNameHeader${index}`]: {
                    content: translator(messages.policy, { lob: MLLOBDisplayService.getLOBPolicyName(policy) })

                },
                [`policyNumber${index}`]: {
                    content: translator(messages.policyX, { policyNumber: policy.policyNumber })
                },
                [`claimSummaryTable${index}`]: {
                    data: _.filter(claimSummariesVM, (claim) => claim.value.policyNumber === policy.policyNumber),
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    openClaimDetailSummaryDialog = (claimNumber) => {
        const translator = this.context;
        const { authHeader } = this.props;
        const { claimSummariesVM } = this.state;
        const getClaimData = claimSummariesVM.filter((claimData) => claimData.value.claimNumber === claimNumber);
        const claimDetailUrl = getClaimData[0].claimDetailURL.value;
        const policyType = getClaimData[0].product.value;
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Claim Details`);
        PolicyService.getClaimsConsolidationEnabled(authHeader).then((isA360ServiceEnabled) => {
            if (isA360ServiceEnabled === true) {
                if (policyType === 'Personal Auto' || policyType === 'Homeowners') {
                    window.open(claimDetailUrl ,'_blank');
                    return;
                }
                const componentProps = {
                    simpleMessage: translator(messages.popupBody),
                    closeSimpleMessage: false
                };
                return this.props.modalContext.showModal(
                    <FormModalPopover {...componentProps} />
                );
            } else {
                const claimDetailPromise = GatewayClaimService.getClaimDetail(claimNumber, authHeader);
                const allClaimsDetailsPromises = Promise.all([claimDetailPromise]);

                allClaimsDetailsPromises.then((data) => {
                    const claimDetail = data[0];

                    let policyVehicles;
                    let claimVehicles;
                    let vehicleIncidents;

                    if (claimDetail.policy.policyType === 'PersonalAuto') {
                        policyVehicles = claimDetail.policy.lobs.personalAuto.vehicles;
                        claimVehicles = claimDetail.lobs.personalAuto.vehicles;
                        vehicleIncidents = claimDetail.lobs.personalAuto.vehicleIncidents;
                    } else if (claimDetail.policy.policyType === 'PersonalUmbrella') {
                        claimVehicles = claimDetail.lobs.personalUmbrella.vehicles;
                        vehicleIncidents = claimDetail.lobs.personalUmbrella.vehicleIncidents;
                    }

                    const componentProps = {
                        title: messages.claimDetail,
                        overrideProps: {
                            adjuster: claimDetail.adjuster,
                            claimContacts: claimDetail.claimContacts,
                            claimDetail: claimDetail,
                            claimActivities: claimDetail.activities || {},
                            notes: claimDetail.notes,
                            payments: claimDetail.payments_ML,
                            policyCoverages: claimDetail.policy.coverages,
                            reserves: claimDetail.reserves_ML,
                            policyType: claimDetail.policy.policyType,
                            policyVehicles: policyVehicles,
                            policy: claimDetail.policy,
                            claimVehicles: claimVehicles,
                            vehicleIncidents: vehicleIncidents
                        },
                        CustomComponent: mlclaimDetailPopup,
                        showFooterOnCustomComponent: true,
                        showActionButton: false,
                        additionalPEStyle: 'customHeaderTitle',
                        cancelBtnLabel: translator(messages.closeBtn)
                    };

                    this.props.modalContext.showModal(
                        <FormModalPopover {...componentProps} />
                    );
                });

                return true;
            }
        });
    }

    renderClaimNumCell = (claim) => {
        return (
            <Button onClick={() => this.openClaimDetailSummaryDialog(claim.claimNumber.value)} type="text">{claim.claimNumber.value}</Button>
        );
    }

    renderLossDateCell = (claim) => {
        return moment(claim.lossDate.value).format('MM/DD/YYYY');
    }

    renderLossTypeCell = (claim) => {
        const { isA360ServiceEnabled } = this.state;
        if (_.isUndefined(claim.lossType_ML)) {
            return '-';
        }

        if (isA360ServiceEnabled === true) {
            const lossType = _.get(claim.value, "claimType_Ext");
            return lossType;
        }

        const translator = this.context;
        const { viewModelService } = this.props;
        const lossTypeTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('ClaimLossType_ML');
        const lossTypeName = lossTypeTypeList.getCode(claim.lossType_ML.value.code).name;
        const lossType = translator({
            id: lossTypeName,
            defaultMessage: lossTypeName
        });

        return _.upperCase(lossType);
    }

    renderdescriptionCell = (claim) => {
        const {
            policySummaries,
            isA360ServiceEnabled
        } = this.state;
        const translator = this.context;

        const policy = policySummaries.find((pol) => {
            return pol.policyNumber === claim.policyNumber.value;
        });

        if (isA360ServiceEnabled === true) {
            const claimDescription = _.get(claim.value, "claimDescription");
            return claimDescription;
        }

        if (policy.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.PERSONAL_AUTO) {
            return translator(messages.vehicleDescription, { year: claim.vehicle_ML.year.value, make: claim.vehicle_ML.make.value, model: claim.vehicle_ML.model.value, trim: claim.vehicle_ML.trim ? claim.vehicle_ML.trim.value : ' ' });
        }
        if (policy.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.HOMEOWNERS) {
            return translator(messages.locationDescription,
                {
                    addressLine1: policy.address_ML.addressLine1,
                    city: policy.address_ML.city,
                    state: policy.address_ML.state,
                    zip: policy.address_ML.postalCode
                });
        }

        if (policy.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.UMBRELLA) {
            let businesActivity;
            let vehcileExposure;
            let locationExposure;
            if (claim.businessActivity_ML.value) {
                businesActivity = claim.businessActivity_ML.value.name;
            }
            if (claim.vehicle_ML.value) {
                vehcileExposure = translator(messages.vehicleDescription,
                    {
                        year: claim.vehicle_ML.year.value,
                        make: claim.vehicle_ML.make.value,
                        model: claim.vehicle_ML.model.value,
                        trim: claim.vehicle_ML.trim ? claim.vehicle_ML.trim.value : ' '
                    });
            }
            if (!claim.businessActivity_ML.value && !claim.vehicle_ML.value) {
                locationExposure = translator(messages.locationDescription,
                    {
                        addressLine1: policy.address_ML.addressLine1,
                        city: policy.address_ML.city,
                        state: policy.address_ML.state,
                        zip: policy.address_ML.postalCode
                    }
                );
            }

            return (
                <span>
                    {businesActivity} {vehcileExposure} {locationExposure}
                </span>
            );
        }
    }

    renderStatusCell = (claim) => {
        if (_.isUndefined(claim.status_ML)) {
            return '-';
        }
        const translator = this.context;
        const statusName = claim.status_ML.value.name;
        const status = translator({
            id: statusName,
            defaultMessage: statusName
        });
        return _.upperCase(status);
    }

    render() {
        const {
            policyWithClaims
        } = this.state;

        const overrides = {
            policySummaryIterable: {
                data: policyWithClaims
            },
            ... this.getPolicySummaryOverrides()
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                renderClaimNumCell: this.renderClaimNumCell,
                renderLossDateCell: this.renderLossDateCell,
                renderdescriptionCell: this.renderdescriptionCell,
                renderLossTypeCell: this.renderLossTypeCell,
                renderStatusCell: this.renderStatusCell,
                openClaimDetailSummaryDialog: this.openClaimDetailSummaryDialog
            }
        };

        return (
            <div className={classNames(styles.claimsummary)}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </div>
        );
    }
}

const MLClaimSummary = withModalContext(MLClaimSummaryWithoutModalContext);

export const AccountClaimSummaryComponent = MLClaimSummary;
export default withRouter(withViewModelService(withAuthenticationContext(MLClaimSummary)));
